import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AttrIndexService } from 'app/services/attr-index.service';
import { ExceptionItem, ExceptionService } from 'app/services/exception.service';
import { ToastrService } from 'ngx-toastr';
import { RecordExceptions } from '../layer-complex/layer-complex.component';

@Component({
	selector: 'app-qc-exceptions',
	templateUrl: './qc-exceptions.component.html',
	styleUrls: ['./qc-exceptions.component.css']
})
export class QcExceptionsComponent implements OnInit {

	// @Input() exceptions: ExceptionItem[] = [];
	@Input() recordExceptions: RecordExceptions = {};

	@Output() onDeleted: EventEmitter<any> = new EventEmitter();

	attributes: {
		name: string;
		prop: string;
	}[] = [{
		name: 'Field',
		prop: 'colName'
	}, {
		name: 'Value',
		prop: 'value'
	}, {
		name: 'QC Code',
		prop: 'gqrCode'
	}, {
		name: 'Reason',
		prop: 'reason'
	}];

	qaNotesGeomColName: string;

	constructor(
		private toastr: ToastrService,
		private attrIndexService: AttrIndexService,
		private exceptionService: ExceptionService
	) { }

	async remove(exc: ExceptionItem) {
		try {
			await this.exceptionService.deleteExceptioin(exc.id);
			this.onDeleted.emit();
			this.toastr.success('Exception removed.');
		} catch (err) {
			this.toastr.error(err.message);
		}
	}
	ngOnInit() {
		this.qaNotesGeomColName = this.attrIndexService.qaNotesGeomColName;
	}

}
